import {match} from 'ts-pattern';

import {head} from 'ramda';

import {FinancingRateMatrixCell} from '@dms/api/vehicle';

/**
 * Resolves the rate that applies to a fine-grained down payment and balloon value: the configured
 * cell of the same term with the highest bracket that does not exceed the requested values.
 */
export function resolveFinancingRateCell(params: {
  cells: FinancingRateMatrixCell[];
  term: number;
  downPayment: number;
  balloonPayment: number | null;
}) {
  const candidates = params.cells
    .filter(
      (cell) =>
        cell.term === params.term &&
        cell.downPayment <= params.downPayment &&
        match(params.balloonPayment)
          .with(null, () => cell.balloonPayment === null)
          .otherwise(
            (balloonPayment) =>
              cell.balloonPayment !== null && cell.balloonPayment <= balloonPayment
          )
    )
    .sort(
      (left, right) =>
        (right.balloonPayment ?? -1) - (left.balloonPayment ?? -1) ||
        right.downPayment - left.downPayment
    );

  return head(candidates) ?? null;
}
